import React from 'react';
import { Card } from 'primereact/card';
const AppointmentBooking = () => {
    const url = "https://app.citasfacil.org/appointments/nubeli-inc";

    return (
        <div className="appointment-booking">
            <Card>
                <iframe
                    src={url}
                    style={{ width: '100%', height: '100vh', border: 'none' }}
                ></iframe>
            </Card>
        </div>
    );
};

export default AppointmentBooking;